import React, { useState } from 'react';
import {
  Card,
  Button,
  Table,
  Tag,
  Space,
  Form,
  Input,
  message,
  Dropdown,
  Menu,
  Empty,
  ConfigProvider,
  Switch
} from 'antd';
import { FilterOutlined } from '@ant-design/icons';
import EmptyData from "../Assets/EmptyData.jpg";


const initialData = [
  { key: '1', sno: '01', categoryName: 'Child 6m - 3Y', categoryId: 'KTKHK12345', status: 'Active', beneficiary: '' },
  { key: '2', sno: '02', categoryName: 'Child 6m - 3Y', categoryId: 'KTKHK12345', status: 'Inactive', beneficiary: '' },
  { key: '3', sno: '03', categoryName: 'Child 6m - 3Y', categoryId: 'KTKHK12345', status: 'Active', beneficiary: '' },
];


function exportCSV(data) {
  const fields = ['sno', 'categoryName', 'categoryId', 'status', 'beneficiary'];
  const header = ['S.no', 'Category Name', 'Category Code', 'Status', 'Beneficiary Mapping (Opt)'];
  const rows = data.map(row => fields.map(field => `"${row[field] || ''}"`).join(','));
  const csvContent = [header.join(','), ...rows].join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'CategoryMaster.csv';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}

const CategoryMaster = () => {
  const [data, setData] = useState(initialData);
  const [isFormPage, setIsFormPage] = useState(false);
  const [editRow, setEditRow] = useState(null);
  const [statusFilter, setStatusFilter] = useState(null); 
  const [form] = Form.useForm();

  const filteredData = statusFilter
    ? data.filter((item) => item.status === statusFilter)
    : data;

  const columns = [
    { title: 'S.no', dataIndex: 'sno', key: 'sno', width:50,ellipsis:true ,align:"center",width:40},
    { title: 'Category Name', dataIndex: 'categoryName', key: 'categoryName',width:150 ,ellipsis:true,align:"center",width:120},
    { title: 'Category ID', dataIndex: 'categoryId', key: 'categoryId',width:150,ellipsis:true,align:"center",width:120},
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      align: "center",
      width:100,
      render: status => (
        <Tag
          color={status === "Active" ? "#eaf9dc" : "#ffeaea"}
          style={{
            color: status === "Active" ? "#48bb78" : "#e53e3e",
            borderRadius: "18px",
            padding: '0 18px',
            fontWeight: 500,
            textAlign: "center"
          }}
        >
          {status}
        </Tag>
      ),
    },
    {
      title: 'Action',
      key: 'action',
      align: "center",
      width:100,
      render: (_, record) => (
        <Space>
          <Button type="link" style={{ color: "#3096E2", fontWeight: 500 }} onClick={() => onEdit(record)}>Edit</Button>
          <Button type="link" danger style={{ color: "#e53e3e", fontWeight: 500 }} onClick={() => onDelete(record.key)}>Delete</Button>
        </Space>
      ),
    },
  ];

  const onAddNew = () => {
    setEditRow(null);
    form.resetFields();
    setIsFormPage(true);
  };

  const onEdit = record => {
    setEditRow(record);
    form.setFieldsValue({
      ...record,
      status: record.status === "Active"
    });
    setIsFormPage(true);
  };

  const onDelete = key => {
    setData(data.filter(row => row.key !== key));
    message.success('Category deleted');
  };

  const onFinish = values => {
    const finalValues = {
      ...values,
      status: values.status ? "Active" : "Inactive",
    };

    if (editRow) {
      setData(data.map(row => row.key === editRow.key ? { ...row, ...finalValues } : row));
      message.success('Category updated');
    } else {
      const nextKey = String(data.length + 1);
      setData([
        ...data,
        {
          ...finalValues,
          key: nextKey,
          sno: nextKey.padStart(2, '0'),
        }
      ]);
      message.success('Category added');
    }
    setIsFormPage(false);
  };

  const onCancel = () => setIsFormPage(false);

  
  const filterMenu = (
    <Menu
      onClick={(e) => setStatusFilter(e.key === "All" ? null : e.key)}
      items={[
        { key: "All", label: "All" },
        { key: "Active", label: "Active" },
        { key: "Inactive", label: "Inactive" },
      ]}
    />
  );

  
  if (isFormPage) {
    return (
      <div style={{
        minHeight: '100vh', width: '100%',
        background: '#f1f4f7', padding: '40px 20px',
        display: 'flex', justifyContent: 'center', alignItems: 'flex-start',
      }}>
        <div style={{ minHeight: '100vh', width: '100%', background: '#fff', padding: '40px' }}>
          <h2 style={{ marginBottom: 32, textAlign: 'center' }}>
            {editRow ? 'Edit Category' : 'New Factory ONBOARDING'}
          </h2>

          <Form
            form={form}
            layout="vertical"
            initialValues={editRow ? { ...editRow, status: editRow.status === "Active" } : { status: true }}
            onFinish={onFinish}
          >
             <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 24 }}>
                     <Form.Item name="status" valuePropName="checked" style={{ marginBottom: 0 }}>
                    <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
                      </Form.Item>
             </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', marginBottom: 16 }}>
              <Form.Item name="categoryName" label="Category Name" style={{ flex: '1 1 250px', maxWidth: 300 }} rules={[{ required: true, message: 'Required' }]}>
                <Input placeholder="Enter category name" />
              </Form.Item>

              <Form.Item name="categoryId" label="Category Code" style={{ flex: '1 1 250px', maxWidth: 300, marginLeft: 15 }} rules={[{ required: true, message: 'Required' }]}>
                <Input placeholder="Enter category code" />
              </Form.Item>
            </div>

            <Form.Item name="beneficiary" label="Beneficiary Mapping (Opt)" style={{ marginBottom: 24, maxWidth: 300 }}>
              <Input placeholder="Optional" />
            </Form.Item>

            
            
            <div style={{ display: 'flex', justifyContent: 'center', gap: '12px', marginTop: 75 }}>
              <Button onClick={() => form.resetFields()} style={{ width: 120 }}>Reset Form</Button>
              <Button type="primary" htmlType="submit" style={{ background: '#1263c9', width: 140 }}>
                {editRow ? 'Update category' : 'Save category'}
              </Button>
              <Button onClick={onCancel} style={{ width: 120 }}>Cancel</Button>
            </div>
          </Form>
        </div>
      </div>
    );
  }

  // TABLE PAGE
  return (
    <div style={{ minHeight: '100vh', width: '100%', background: '#f1f4f7', padding: '20px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '24px' }}>
        <Card style={{ width: '200px', height: '144px', marginBottom: '16px' }}>
          <div style={{ fontWeight: 'bold', fontSize: 18 }}>Overall Category</div>
          <div style={{ fontSize: 34, color: '#3498ff', fontWeight: 600, marginTop: '12px', textAlign: "center" }}>{data.length}</div>
        </Card>

        <div style={{ display: 'flex', gap: '12px' }}>
          <Button type="primary" style={{ background: "#884af1", fontWeight: 500 }} onClick={() => exportCSV(data)}>Export</Button>
          <Button type="primary" style={{ background: "#05622C", fontWeight: 500 }} onClick={onAddNew}>Add New Cat</Button>

          <Dropdown overlay={filterMenu} trigger={['click']}>
            <Button style={{ border: "2px solid #d2d2d2", background: "white", color: "#1e78e3", fontWeight: 500 }} icon={<FilterOutlined />}>
              Filter
            </Button>
          </Dropdown>
        </div>
      </div>

      <ConfigProvider renderEmpty={() => (
        <Empty image={EmptyData} description="No CategoryMaster Data Available" imageStyle={{ height: 200 }} />
      )}>
        
        
                <Table
              
                columns={columns}
                dataSource={filteredData}
                size="small"
                bordered
                pagination={false}
                />
                </ConfigProvider>
    
    </div>
  );
};

export default CategoryMaster;
